import {
  ComponentConfig,
  LayoutTypes,
  ComponentType,
  FlexDirection,
  ActionType,
} from "../services/types/ComponentTypes";

export const screen_103_inspection: ComponentConfig[] = [
  {
    componentType: LayoutTypes.SCREEN_GROUP,
    fabAction: { type: "add", screenId: "107" },
    title: "Inspection",
    style: {
      backgroundColor: "#F9FAFB", // bg-gray-50 from design system
    },
    childComponents: [
      {
        componentType: LayoutTypes.GROUP,
        style: {
          backgroundColor: "#ffffff",
          direction: FlexDirection.COLUMN,
          borderRadius: 12, // Design system: rounded-lg (12px)
          padding: 16, // Design system: p-4 (16px)

        },
        childComponents: [
          {
            componentType: ComponentType.SUMMARY_LIST,
            titleValue: "vin_no",
            Name: "vehiclein_summary",
            style: {
              maxHeight: "calc(100vh - 350px)", // Adjust height to fit view
            },
            Form: {
              Name: "vehiclein_summary",
              TableName: "vehicle_in",
              View: "view_vehiclein",
              Filter:
                "view_vehiclein.soft_delete=0 order by view_vehiclein.created_at desc",
              Fields: [
                {
                  IncludeLabel: true,
                  Label: "ID#",
                  BindValue: "id",
                  Json_Attribute: "id",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: false,
                },
                {
                  IncludeLabel: true,
                  Label: "Jobcard ID",
                  BindValue: "jobcard_id",
                  Json_Attribute: "jobcard_id",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: false,
                },
                {
                  IncludeLabel: true,
                  Label: "VIN No.",
                  BindValue: "vin_number",
                  Json_Attribute: "vin_no",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "VIN date",
                  IsMandatory: false,
                  BindValue: "vin_date",
                  Json_Attribute: "vin_date",
                  componentType: ComponentType.DATE_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Customer name",
                  IsMandatory: false,
                  BindValue: "customername",
                  Json_Attribute: "customername",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Vehicle No.",
                  IsMandatory: false,
                  BindValue: "platenumber",
                  Json_Attribute: "platenumber",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                  StickyColumn: "left" as const,
                  StickyWidth: "200px",
                },
                {
                  IncludeLabel: true,
                  Label: "Jobcard No.",
                  IsMandatory: false,
                  BindValue: "jobcard_no",
                  Json_Attribute: "jobcard_no",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                  StickyColumn: "left" as const,
                  StickyWidth: "200px",
                },
                {
                  IncludeLabel: true,
                  Label: "Parts issue",
                  IsMandatory: false,
                  BindValue: "issue_status",
                  Json_Attribute: "issue_status",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                  StickyColumn: "left" as const,
                  StickyWidth: "200px",
                },
                {
                  IncludeLabel: false,
                  Label: "Gate Pass ID",
                  BindValue: "gate_pass_id",
                  Json_Attribute: "gate_pass_id",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: false,
                },
              ],
            },
            workflow: [
              {
                Name: "Inspected",
                Label: "Inspected",
                States: ["Inspected"],
                Action: "Inspect",
                Screen: "modulev1/vehiclein_add",
                Action_ref_column: "inspection_id",
              },
              {
                Name: "Estimated",
                Label: "Estimated",
                Action: "Estimate",
                EnableOn: ["Inspected", "Rejected"],
                States: ["Estimated"],
                Screen: "modulev1/estimation_add",
                ActionArgs: {
                  parentid: "<id>",
                },
                Action_ref_column: "estimate_id",
              },
              {
                Name: "Approved",
                Label: "Approved",
                Action: "Approve",
                EnableOn: ["Estimated"],
                States: ["Approved", "Rejected", "Put on hold"],
                Screen: "modulev1/estimateapproval",
                Action_ref_column: "approved_id",
              },
              {
                Name: "jobCard",
                Label: "Job card",
                Action: "Job card",
                EnableOn: ["Approved", "QC Rejected"],
                States: ["Job card"],
                Screen: "modulev1/jobcard_add",
                ActionArgs: {
                  parentid: "<approved_id>",
                },
                Action_ref_column: "jobcard_id",
              },
              {
                Name: "QC Approved",
                Label: "QC Approved",
                EnableOn: ["Job card"],
                Action: "QC Approve",
                States: ["QC Approved", "QC Rejected"],
                Screen: "modulev1/qc_approve",
                Action_ref_column: "qc_approved_id",
              },
              {
                Name: "Invoiced",
                Label: "Invoiced",
                EnableOn: ["QC Approved"],
                Action: "Create invoice",
                States: ["Invoiced"],
                Screen: "modulev1/invoice_add",
                ActionArgs: {
                  parentid: "<jobcard_no>",
                },
                Action_ref_column: "invoice_id",
              },
              {
                Name: "Gate Pass Issued",
                Label: "Gate Pass Issued",
                EnableOn: ["Invoiced"],
                Action: "Create Gate Pass",
                States: ["Gate Pass Issued"],
                Screen: "modulev1/gate_pass_issue",
                ActionArgs: {
                  parentid: "<jobcard_no>",
                },
                Action_ref_column: "gate_pass_id",
              },
              {
                Name: "Close",
                Label: "Close",
                EnableOn: ["Gate Pass Issued"],
                Action: "Close",
                States: ["Closed"],
                Screen: "modulev1/close_jobcard",
                Action_ref_column: "closed_id",
              },
            ],
          },
        ],
      },
    ],
  },
];
